{
    "raportakimhedefaylik": {
        "Baslik": "Takım Hedef Aylık Raporu",
        "Yil": "Yıl",
        "Ay": "Ay",
        "Takim": "Takım",
        "Detay": "Performans Detayı",
        "Urun": "Ürün / Grup",
        "HedefAdet": "Hedef Adet",
        "HedefTutar": "Hedef Tutar",
        "GerceklesenAdet": "Gerçekleşen Adet",
        "GerceklesenTutar": "Gerçekleşen Tutar",
        "Kullanici": "Kullanıcı",
        "Ara": "Sorgula",
        "Temizle": "Temizle"
    }
}
